import { render, staticRenderFns } from "./Academic.vue?vue&type=template&id=0cd5f264&scoped=true&"
import script from "./Academic.vue?vue&type=script&lang=js&"
export * from "./Academic.vue?vue&type=script&lang=js&"
import style0 from "./Academic.vue?vue&type=style&index=0&id=0cd5f264&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd5f264",
  null
  
)

export default component.exports